// extracted by mini-css-extract-plugin
var _1 = "signs-overlay__oWhuS";
export { _1 as "signs-overlay" }
